var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 23C17.5304 23 18.0391 22.7893 18.4142 22.4142C18.7893 22.0391 19 21.5304 19 21V3C19 2.46957 18.7893 1.96086 18.4142 1.58579C18.0391 1.21071 17.5304 1 17 1H7C6.46957 1 5.96086 1.21071 5.58579 1.58579C5.21071 1.96086 5 2.46957 5 3V21C5 21.5304 5.21071 22.0391 5.58579 22.4142C5.96086 22.7893 6.46957 23 7 23H17ZM7 3H9.5L10 4H14L14.5 3H17V21H7V3ZM13 19C13 19.1978 12.9414 19.3911 12.8315 19.5556C12.7216 19.72 12.5654 19.8482 12.3827 19.9239C12.2 19.9996 11.9989 20.0194 11.8049 19.9808C11.6109 19.9422 11.4327 19.847 11.2929 19.7071C11.153 19.5673 11.0578 19.3891 11.0192 19.1951C10.9806 19.0011 11.0004 18.8 11.0761 18.6173C11.1518 18.4346 11.28 18.2784 11.4444 18.1685C11.6089 18.0586 11.8022 18 12 18C12.2652 18 12.5196 18.1054 12.7071 18.2929C12.8946 18.4804 13 18.7348 13 19Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile2);
export default __webpack_public_path__ + "static/media/mobile-2.d4f7efee9d040f986273fce431f723fe.svg";
export { ForwardRef as ReactComponent };